const imageBrightness = ["100","80","60","40","20","10","5"];

//const textColors = ["#FFFFFF",	"#C8C8C8", "#888888","#585858","#484848","#383838","#282828"];
//KEEP

const textColors = ["#FFFFFF",	"#FFFFFF", "#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF"];

const beTheFirstAudioUrl = "https://firebasestorage.googleapis.com/v0/b/slictionary-fc2a0.appspot.com/o/audio%2FBe%20the%20First.m4a?alt=media&token=611721e1-3ac6-45cb-ae09-0526976068c1";

export {imageBrightness,textColors,beTheFirstAudioUrl};